/* Version 3.0.29 */
/*global $:false */
/*global InFlightDCType:false */

var InFlight = InFlight || {};
InFlight.NLX = InFlight.NLX || {};
InFlight.NLX.Cfg = InFlight.NLX.Cfg || {};

(function () {
    'use strict';

    var defaultConfig = {};

    InFlight.NLX.Cfg.setDefaults = function (_defaultConfig) {
        if (_defaultConfig) {
            defaultConfig = _defaultConfig;
        }
    };

    var SCROLL_SUFFIX = 'scroll';

    function _clearScrollStates() {
        var keys = Object.keys(sessionStorage);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key) {
                var pos = key.indexOf(SCROLL_SUFFIX);
                if (pos !== -1 && pos === key.length - SCROLL_SUFFIX.length) {
                    sessionStorage.removeItem(key);
                }
            }
        }
    }

    function _saveScrollState() {
        var scrollY = '' + $(document).scrollTop();
        sessionStorage[sessionStorage.currentPageKey + SCROLL_SUFFIX] = scrollY;
    }

    function _restoreScrollState(currentTemplate) {
        var pageKey = currentTemplate.replace(/[^\w\s]/gi, '');
        sessionStorage.currentPageKey = pageKey;
        var prevScroll = sessionStorage[pageKey + SCROLL_SUFFIX];
        if (prevScroll === 'null') {
            prevScroll = null;
        }
        if (prevScroll) {
            sessionStorage.removeItem(pageKey + SCROLL_SUFFIX);

            var scrollAmount = Number(prevScroll);

            setTimeout(function () {
                window.scrollTo(0, scrollAmount);
            }, 2);

        }
    }

    //var InFlightPSHelper = (function (myInFlightDCInstance) {
    var InFlightPSHelperType = function (myInFlightDCInstance) {
        function initialize(psConfig) {
            if (psConfig.isActivityGuide) {
                ProcessActivityGuide(psConfig);
                return;
            }

            if (!myInFlightDCInstance) {
                myInFlightDCInstance = new InFlightDCType();
            }

            //will check the psConfig, then defaultConfig and finally fallback onto the provided defaultValue
            var _getConfig = function (name, defaultValue) {
                if (psConfig[name] !== undefined) {
                    return psConfig[name];
                }

                if (defaultConfig[name] !== undefined) {
                    return defaultConfig[name];
                }

                return defaultValue;
            };

            var myNLXConfig = {
                targetUrl: psConfig.targetUrl,
                targetPath: psConfig.targetPath,
                targetSystem: psConfig.targetSystem,
                debugMode: psConfig.debugMode,
                showLoading: _getConfig('showLoading', true),
                forceReload: psConfig.forceReload,
                scope: psConfig.scope,
                currentTemplate: psConfig.currentTemplate,
                manualRequestObj: psConfig.manualRequestObj,
                trackTemplates: _getConfig('trackTemplates', true),
                targetVerb: _getConfig('targetVerb', 'GET'),
                redirectErrorResponseToMaintenancePage: _getConfig('redirectErrorResponseToMaintenancePage'),
                simulate: psConfig.simulate,
                simulationData: psConfig.simulationData,
                sourceContext: _getConfig('sourceContext', ''),
                targetContext: _getConfig('targetContext', ''),
                onStateChange: psConfig.onStateChange,
                followProposedTemplate: psConfig.followProposedTemplate,
                callback: psConfig.callback,
                beforeProcessResponse: psConfig.beforeProcessResponse,
                afterProcessResponse: function (data, nlxConfig) {
                    // This is the additional work we want to do after the xhr response...

                    var scopeFilter = '';

                    if (psConfig.afterProcessResponse) {
                        psConfig.afterProcessResponse(data, nlxConfig);
                    }

                    //this restores the scroll state of the page
                    var currentTemplate = data.Info.ProposedTemplate;
                    if (currentTemplate && currentTemplate !== "/pages/Events-BS3/event-details.aspx") {
                        _restoreScrollState(currentTemplate);
                    }

                    if (psConfig.scope) {
                        scopeFilter = '[data-if-scope="' + psConfig.scope + '"]';
                    }

                    $(nlxConfig.targetContextSelector + scopeFilter + '[data-if-ps-clickable="true"]').each(function () { //'data-if-ps-clickable' was a totally arbitrary choice of attribute names. It has no significance, and is just a way of flagging which anchors we should be post-fixing.
                        var $thisElement = $(this);
                        //debugger;
                        /*
                        if ($thisElement.attr('href') == '#') {
                            $thisElement.attr('href', '');
                        }
                        */
                        //console.log('binding click event for ' + $thisElement + ' from jQuery guid ' + $.guid);

                        // if ($thisElement[0].onclick) {
                        // 	debugger;
                        // }

                        var clickableFn = function (e) {
                            var selector,
                                thisId,
                                thisDIL,
                                thisName,
                                thisICAction,
                                preserveDefault = $thisElement.attr('data-if-ps-preserve-default');

                            if (!preserveDefault) {
                                e.preventDefault();
                            }

                            thisId = $thisElement.attr('id');
                            thisName = $thisElement.attr('name');
                            thisDIL = $thisElement.attr('data-if-label');
                            thisICAction = $thisElement.attr('data-if-ps-icaction');

                            if (thisId) {
                                selector = '[id=\'' + thisId + '\']';
                            } else if (thisName) {
                                selector = '[name=\'' + thisName + '\']';
                            } else if (thisDIL) {
                                selector = '[data-if-label=\'' + thisDIL + '\']';
                            } else if (thisICAction) {
                                selector = '[data-if-ps-icaction=\'' + thisICAction + '\']';
                            }

                            if (selector) {
                                var ssKey = $thisElement.is('button:has(i[class*=\'fa-search\'])') ? 'lookupFocusSelector' : 'targetFocusSelector';
                                sessionStorage.setItem(ssKey, selector);

                            }

                            if (nlxConfig.sourceContext) {
                                var sourceContextOverride = '';
                                var $wrapper = $thisElement.closest('[data-if-context-wrapper]');
                                if ($wrapper.length > 0) {
                                    var wrapperContext = $wrapper.attr('data-if-context-wrapper');
                                    if (wrapperContext.toUpperCase() !== 'UNIVERSAL') {
                                        sourceContextOverride = wrapperContext;
                                        if (!sourceContextOverride) {
                                            sourceContextOverride = '';
                                        }
                                    }
                                }

                                if (sourceContextOverride.length > 0) {
                                    nlxConfig.originalSourceContext = nlxConfig.sourceContext;
                                    nlxConfig.sourceContext = sourceContextOverride;
                                }
                            }

                            var cancelClick = false;

                            _saveScrollState();
                            //console.log("caching last scroll: " + scrollY);

                            if (psConfig.beforeClick) {
                                cancelClick = psConfig.beforeClick($thisElement, nlxConfig);
                                if (cancelClick) {
                                    //console.log('Click action cancelled');
                                    return;
                                }
                            }

                            var icAction = $thisElement.attr('data-if-ps-icaction');
                            if (!icAction) {
                                icAction = $thisElement.attr('name');
                            }
                            //TODO: this doesn't work as a setDefault.  Why?
                            // To reproduce, try saving a phone number change
                            //icAction = _setDefault(icAction, $thisElement.attr('id'));
                            if (!icAction) {
                                icAction = $thisElement.attr('id');
                            }

                            if (!icAction) {
                                //debugger;
                            }
                            var $historyContentSource = $thisElement.data('ContentSource');
                            if ($historyContentSource) {
                                nlxConfig.ContentSourceOverride = $historyContentSource;
                                if (nlxConfig.currentTemplate) {
                                    nlxConfig.currentTemplate = 'history';
                                }
                            }


                            var $icActionElement = $(nlxConfig.sourceContextSelector + '#ICAction', $historyContentSource);
                            if ($icActionElement.length === 0) {
                                $icActionElement = $(nlxConfig.sourceContextSelector + 'input[name="ICAction"]', $historyContentSource);
                            }

                            if ($icActionElement.length > 0) {
                                $icActionElement.attr('value', icAction);
                            }

                            // Because checkboxes only get added to a form POST when they're checked,
                            // PS typically adds a hidden input and sets its value to 'Y' or 'N' in the
                            // onClick() event of the visible checkbox.
                            // Instead, to abstract this nuance, we can search for the related input
                            // and assign values here.

                            if ($thisElement.attr('data-if-related-input')) {
                                if ($thisElement[0].checked) { //NOTE:  if this goes from a checked to an unchecked state, does the related input get cleared?
                                    setRelatedInput($thisElement.attr('data-if-related-input'), $thisElement.val(), $thisElement[0].checked);
                                }
                            }

                            if ($thisElement.attr('data-if-ps-clickable') && $thisElement[0].nodeName === 'INPUT' && ($thisElement.attr('type') === 'checkbox' || $thisElement.attr('data-if-has-related-input'))) {
                                findAndSetRelatedInput($thisElement);
                            } else {
                                $('input[type=checkbox], input[data-if-has-related-input]').each(function () {
                                    findAndSetRelatedInput($(this));
                                });
                            }

                            //TODO: account for any changes to NLXConfig through click events
                            nlxConfig.forceReload = psConfig.forceReload;

                            //TODO: this is a cheap hack -- ultimately we want to be able to pass in the nlxConfig that actually belongs to this context
                            // the best way to do this is probably to maintain an array of configs
                            /*
                            nlxConfig.originalSourceContext = nlxConfig.sourceContext;
                            if (nlxConfig.targetContext.length > 0 && nlxConfig.sourceContext != nlxConfig.targetContext) {
                                nlxConfig.sourceContext = nlxConfig.targetContext;
                            }
                            */
                            var urlBackup = nlxConfig.targetUrl;
                            if (nlxConfig.initialParams) {
                                //Apply MHParams top the URL
                                if (nlxConfig.targetUrl.indexOf('?') > -1) {
                                    nlxConfig.targetUrl += '&';
                                } else {
                                    nlxConfig.targetUrl += '?';
                                }
                                nlxConfig.targetUrl += 'IF-MHParams=' + encodeURIComponent(nlxConfig.initialParams);
                                //console.log("initialParams url: " + nlxConfig.targetUrl);
                            }
                            myInFlightDCInstance.init(nlxConfig);
                            nlxConfig.targetUrl = urlBackup;

                            if (psConfig.afterClick) {
                                psConfig.afterClick($thisElement, nlxConfig);
                            }

                            //Switch the source context back
                            if (sourceContextOverride) {
                                nlxConfig.sourceContext = nlxConfig.originalSourceContext;
                                nlxConfig.originalSourceContext = null;
                            }
                        };

                        var thisHref = $thisElement.attr('href');
                        if (thisHref && thisHref.indexOf('submitAction_') > -1) {
                            var elementName = thisHref.replace(/javascript\s*:\s*submitAction_win[0-9]+\(\s*document\.win[0-9]+\s*,\s*['"]/g, '');
                            elementName = elementName.replace('\');', '');
                            $thisElement.attr('data-if-ps-icaction', elementName);
                            $thisElement.attr('href', '#');
                        }

                        if ($thisElement.is('select') || $thisElement.prop('type') === 'checkbox' || $thisElement.prop('type') === 'radio' ||
                            $thisElement.prop('type') === 'text' || $thisElement.is('textarea')) {
                            //console.log("select or checkbox or radio detected, clickable applied to onChange()");
                            $thisElement.off('change').unbind('change').change(clickableFn);
                        } else {
                            var preserveDefault = $thisElement.attr('data-if-ps-preserve-default');
                            preserveDefault = false;
                            if (preserveDefault && preserveDefault.toLowerCase() === 'true') {
                                $thisElement.bind('click', function () {
                                    clickableFn($thisElement);
                                    setTimeout(function () {
                                        //$thisElement.unbind("click")
                                    }, 100);
                                });
                            } else {
                                //consider setting the $thisElement[0].onclick to null
                                $thisElement.off('click').unbind('click').click(clickableFn);
                            }
                        }

                    });

                    nlxConfig.targetVerb = 'POST';

                    if (psConfig.afterFirstInit) {
                        psConfig.afterFirstInit(nlxConfig);
                        psConfig.afterFirstInit = null;
                    }

                    // Show any alert messages that might exist
                    try {
                        var errorHtml = $('#popupMessageContent').html();
                        if (errorHtml.length === 0) {
                            errorHtml = $('[data-if-cloned-from=\'popupMessageContent\']:first()').html();
                        }
                        errorHtml = errorHtml.replace('&nbsp;', ' ');
                        errorHtml = errorHtml.trim();
                        if (errorHtml.length > 0) {
                            $('#popupMessageModal').modal('show');
                        }
                    } catch (e) {

                    }

                    // Show any alert messages that might exist
                    try {
                        if (data.CaptureResults.attachmentWrapper && data.CaptureResults.attachmentWrapper[0].Children.attachmentLink) {
                            $('#attachmentWrapperModal *[href*=\'/view/\'],*[href*=\'/detach/\']').each(function () {
                                var $this = $(this);
                                var thisHref = $this.attr('href');
                                if (thisHref) {
                                    thisHref = thisHref.replace('/nlx3/', '/');
                                    $this.attr('href', thisHref.replace('/view/', '/viewredirect/'));
                                }
                            });

                            $('#attachmentWrapperModal').modal('show');
                        }
                    } catch (e) {

                    }



                }
            };

            if (psConfig.beforeFirstInit) {
                psConfig.beforeFirstInit(myNLXConfig);
            }

            var isUrlSet = false;
            var adjustedUrl = myNLXConfig.targetPath;
            if (myNLXConfig.targetUrl) {
                isUrlSet = true;
                adjustedUrl = myNLXConfig.targetUrl;
            }
            var urlBackup = adjustedUrl;
            if (psConfig.initialParams) {
                //Apply MHParams top the URL
                if (adjustedUrl.indexOf('?') > -1) {
                    adjustedUrl += '&';
                } else {
                    adjustedUrl += '?';
                }
                adjustedUrl += 'IF-MHParams=' + encodeURIComponent(psConfig.initialParams);
                console.log('initialParams url: ' + adjustedUrl);
            }

            if (isUrlSet) {
                myNLXConfig.targetUrl = adjustedUrl;
            } else {
                myNLXConfig.targetPath = adjustedUrl;
            }

            myInFlightDCInstance.init(myNLXConfig);

            //Restore the original path/url
            if (isUrlSet) {
                myNLXConfig.targetUrl = urlBackup;
            } else {
                myNLXConfig.targetPath = urlBackup;
            }

        }


        function ProcessActivityGuide(psConfig) {
            psConfig.callback = null;

            //console.log("In ProcessActivityGuide");
            ProcessActivityGuideWelcomePage(psConfig);
        }


        function ProcessActivityGuideWelcomePage(psConfig) {
            var ptalScriptUrl;
            var welcomeNLXConfig = {
                targetUrl: psConfig.targetUrl,
                targetPath: psConfig.targetPath,
                targetSystem: psConfig.targetSystem,
                followProposedTemplate: false,
                manualRequestObj: [{
                    'Lbl': 'ptalScriptUrlSource',
                    'Src': '#ptalPgltAreaFrameDiv iframe',
                    'Data': 'src'
                }],
                callback: function (data) {
                    //console.log("In callback for ProcessActivityGuideWelcomePage");
                    if (!jQuery.isEmptyObject(data.CaptureResults)) {
                        ptalScriptUrl = data.CaptureResults.ptalScriptUrlSource[0].Properties.src;
                    }
                    if (ptalScriptUrl) {
                        ProcessActivityGuidePtalIscript(psConfig, ptalScriptUrl);
                    }
                }
            };

            var InFlightDCInstancePAG = new InFlightDCType(false);
            InFlightDCInstancePAG.init(welcomeNLXConfig);

        }


        function ProcessActivityGuidePtalIscript(psConfig, ptalScriptUrl) {
            var ptalScriptNLXConfig = {
                targetUrl: ptalScriptUrl,
                followProposedTemplate: false,
                manualRequestObj: [{
                    'Lbl': 'scriptContent',
                    'Src': 'script:contains(\'ptalPageletArea.id\')',
                    'Data': 'html'
                }],
                callback: function (data, ptalScriptNLXConfig, ptalScriptUrl) {
                    //console.log("In callback for ProcessActivityGuidePtalIscript");
                    if (!jQuery.isEmptyObject(data.CaptureResults)) {
                        var rawScript = data.CaptureResults.scriptContent[0].Properties.html;
                        if (rawScript) {
                            rawScript = rawScript.trim();
                            var ptalPageletArea = {};
                            var rawScriptLines = rawScript.split('\n');

                            //remove the last line (that sets ptEvent)
                            rawScriptLines = rawScriptLines.splice(0, 4);
                            rawScript = rawScriptLines.join('\n');

                            // validate that the script is good before doing a potentially dangerous eval()
                            if (rawScript.indexOf('ptalPageletArea.id') > -1 && rawScriptLines.length === 4) {
                                eval(rawScript);
                            }

                            var prefix = data.Info.ReferringTarget.split('/s/WEBLIB')[0];
                            if (prefix) {
                                var suffix = this.TargetUrl.split('&TEMPLATE_ID=')[1];
                                if (suffix) {
                                    suffix = '&TEMPLATE_ID=' + suffix;
                                }

                                var pageletUrl = prefix + '/?cmd=refreshPglt';
                                pageletUrl += '&pageletname=' + ptalPageletArea.pagelets[0];
                                pageletUrl += '&PTAL_ID=' + ptalPageletArea.id;
                                pageletUrl += '&PTAL_TAB=' + ptalPageletArea.groupId;
                                pageletUrl += '&PAGELET_OBJNAME=' + ptalPageletArea.pagelets[0];
                                pageletUrl += suffix;
                            }
                            ProcessActivityGuideLeftNavPagelet(psConfig, pageletUrl);

                        }
                    }

                }


            };

            var InFlightDCInstancePAG = new InFlightDCType(false);
            InFlightDCInstancePAG.init(ptalScriptNLXConfig);

        }


        function ProcessActivityGuideLeftNavPagelet(psConfig, leftNavPageletUrl) {
            var pageletNLXConfig = {
                targetUrl: leftNavPageletUrl,
                followProposedTemplate: false,
                manualRequestObj: [{
                    'Lbl': 'navGroup',
                    'Src': 'div[onclick*=\'toggleSummery\']:has(a:not(.ActionItem))',
                    'Data': 'null',
                    'Children': [{
                        'Lbl': 'navGroupLink',
                        'Src': 'a:not(.ActionItem)',
                        'Data': 'text'
                    },
                        {
                            'Lbl': 'navLink',
                            'Src': '~div:eq(0) a.ActionItem',
                            'Data': 'id onclick text',
                            'Children': [{
                                'Lbl': 'navLinkStatus',
                                'Src': 'img',
                                'Data': 'alt src'
                            }]
                        }]
                }],
                callback: function (data) {
                    //console.log("In callback for ProcessActivityGuideLeftNavPagelet");
                    if (!jQuery.isEmptyObject(data.CaptureResults)) {
                        ProcessActivityGuideParseLeftNav(data.CaptureResults.navGroup, this.TargetUrl, data.Info.ReferringTarget, psConfig);
                    }

                }

            };

            var InFlightDCInstancePAG = new InFlightDCType(false);
            InFlightDCInstancePAG.init(pageletNLXConfig);

        }

        function AIPreProcessing(serviceID, parameters) {
            return '?SERVICEID=' + serviceID + '&PARAMETERS=' + parameters;
        }

        function ProcessActivityGuideParseLeftNav(navGroup, targetUrl, referringUrl, psConfig) {
            if (navGroup) {
                var groups = [];
                var output = {};
                for (var i = 0; i < navGroup.length; i++) {
                    var links = [];
                    var thisGroup = {};
                    var thisGroupSource = navGroup[i];
                    thisGroup.name = thisGroupSource.Children.navGroupLink[0].Properties.text;
                    for (var j = 0; j < thisGroupSource.Children.navLink.length; j++) {
                        var thisLinkSource = thisGroupSource.Children.navLink[j];
                        var thisLink = {};
                        thisLink.name = thisLinkSource.Properties.text;
                        thisLink.id = thisLinkSource.Properties.id;
                        thisLink.statusText = thisLinkSource.Children.navLinkStatus[0].Properties.alt;
                        thisLink.statusImg = thisLinkSource.Children.navLinkStatus[0].Properties.src;
                        var onClickContent = thisLinkSource.Properties.onclick.replace('return false;', '');
                        var aiUrl;
                        // parse the AIPreProcessing URL from the onclick content
                        var prefix = referringUrl.split('/?cmd=refreshPglt')[0];
                        if (prefix) {
                            // make sure this is safe before eval();
                            if (onClickContent.indexOf('AIPreProcessing(') > -1) {
                                aiUrl = prefix + '/s/WEBLIB_PTAI.ISCRIPT1.FieldFormula.IScript_AIPreProcessing';
                                onClickContent = 'aiUrl += ' + onClickContent.split(';')[0] + ';';
                                eval(onClickContent);
                            }
                        }
                        thisLink.href = ExecuteAIPreProcessing(aiUrl);
                        links.push(thisLink);
                    }
                    thisGroup.links = links;
                    groups.push(thisGroup);
                }
                output.groups = groups;

                if (psConfig.agCallback) {
                    psConfig.agCallback(output);
                }
            }

        }

        function ExecuteAIPreProcessing(aiUrl) {
            var output;
            var jqxhr = $.ajax({
                type: 'GET',
                url: aiUrl.replace('\/NLX', '\/bypassNLX').replace('\/psp\/', '\/psc\/'),
                async: false,
                crossDomain: true,
                xhrFields: { withCredentials: true }
            }).done(function (data) {
                if (data) {
                    output = data.trim().split(',')[3];
                }
            }).fail(function (data) {
                //alert(JSON.stringify(data));
            });

            output = 'javascript:InFlightPSHelper.processDirectLink("' + output.replace('\/bypassNLX', '\/NLX') + '");';
            return output;
        }

        function setRelatedInput(relatedInputId, checkValue, isChecked) {
            var $relatedInput = $('[id=\'' + relatedInputId + '\']');

            if (isChecked || (!isChecked && $relatedInput.val())) {

                if ($relatedInput.length === 0) {
                    // try against name
                    $relatedInput = $('[name=\'' + relatedInputId + '\']');
                }
                if ($relatedInput.length > 0) {
                    $relatedInput.val(checkValue);
                }
            }
        }

        function findAndSetRelatedInput($elem) {
            var thisName = $elem.attr('name');
            if (!thisName) {
                thisName = $elem.attr('id');
            }
            if (thisName) {
                var onVal = $elem.attr('data-if-on-val');
                if (!onVal) {
                    onVal = 'Y';
                }

                var offVal = $elem.attr('data-if-off-val');
                if (!offVal) {
                    offVal = 'N';
                }

                var isChecked = $elem[0].checked;
                var checkValue = isChecked ? onVal : offVal;
                if (checkValue === 'null') {
                    checkValue = '';
                }
                var relatedId = null;
                if (thisName.indexOf('$$') > -1) {
                    relatedId = thisName.replace('$$', '$$$chk$');
                    if (document.getElementById(relatedId) !== null) {
                        setRelatedInput(relatedId, checkValue, isChecked); // we have to provide '$$$' to effect a replacement of '$$'.
                        return;
                    }
                }
                if (thisName.indexOf('$') > -1) {
                    relatedId = thisName.replace('$', '$chk$');
                    if (document.getElementById(relatedId) !== null) {
                        setRelatedInput(relatedId, checkValue, isChecked);
                        return;
                    }
                }
                setRelatedInput(thisName + '$chk', checkValue, isChecked);
            }
        }

        function _submitAction_win0(form, name) {
            var $icActionElement = $(nlxConfig.sourceContextSelector + '#ICAction');
            if ($icActionElement.length === 0) {
                $icActionElement = $(nlxConfig.sourceContextSelector + 'input[name="ICAction"]');
            }

            if ($icActionElement.length > 0) {
                $icActionElement.attr('value', name);
            }

            if (!myInFlightDCInstance) {
                myInFlightDCInstance = new InFlightDCType();
            }

            myInFlightDCInstance.init(nlxConfig);

            return false;
        }

        function _processDirectLink(targetUrl) {
            var psConfig = {
                targetUrl: targetUrl
            };

            initialize(psConfig);

            return false;

        }

        function _hAction_win0(form, name, dummy1, dummy2, dummy3, dummy4, dummy5) {
            _submitAction_win0(form, name);
        }

        var ptCommonObj = {};
        ptCommonObj.updatePrompt = function (form, name) {
            submitAction_win0(form, name); //TODO should this be _submitAction_win0
        };

        function _setupTimeout() { }
        function _setupTimeout2() { }
        function _addchg_win0(element) { }
        function _doFocus_win0(element, dummy1, dummy2) { }
        function _isPromptKey(event) { return false; }
        function _doEdits_win0(element, dummy1, dummy2, dummy3, dummy4, dummy5, dummy6, dummy7, dummy8) { }

        // Undefined
        // MOpopupObj_win0 = {
        // 	StartPopup: function (element, dummy1, dummy2, dummy3) { },
        // 	StopPopup: function () { }
        // };

        function jqSelector(str) {
            //return a clean jQ selector
            return str.replace(/([;&,\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1');
        }

        //set date for an HTML5 date Input from raw text of format "mm*dd*yyy"
        function setHTML5Date(dateInput, slashesDate) {
            var month = slashesDate.substring(0, 2);
            var day = slashesDate.substring(3, 5);
            var year = slashesDate.substring(6);
            var gooddate = year + '-' + month + '-' + day;

            //var ts = Date.parse(gooddate);
            var ts = Date.parseExact(gooddate, 'yyyy-M-d');

            var newDate = new Date(ts + 12 * 60 * 60 * 1000);
            //console.log(slashesDate + " --> " + gooddate + " --> " + newDate);

            //there are two ways to set a date. the first way is broken on Apple
            //dateInput.valueAsDate = newDate;
            $(dateInput).val(gooddate);

            return newDate;
        }


        //return string date of format "mm/dd/yyy" from HTML5 date input string
        function getPeopleSoftSlashesDate(inputDateString) {
            //console.log("Raw Date " + inputDateString);

            //try and set the time to 12 noon so that timezone errors don't push us back one day
            //for example Chrome Desktop uses GMT (which would result in an error), BlackBerry 10 uses local TZ of EST
            var inputDate = new Date(inputDateString);
            inputDate.setTime(inputDate.getTime() + 12 * 60 * 60 * 1000);

            var day = inputDate.getDate();
            var month = inputDate.getMonth() + 1;
            var year = inputDate.getFullYear();
            var formattedDate = month + '/' + day + '/' + year;
            //console.log(inputDate + " Orcale formatted date is " + formattedDate);

            if (formattedDate.indexOf('NaN') >= 0) {
                return '';
            }
            else {
                return formattedDate;
            }
        }

        function stripHtml(textarea) {
            var strInputCode = textarea.innerHTML;

            /*  This line is optional, it replaces escaped brackets with real ones,  i.e. &lt; is replaced with < and &gt; is replaced with > */
            strInputCode = strInputCode.replace(/&(lt|gt);/g, function (strMatch, p1) {
                return (p1 === 'lt') ? '<' : '>';
            });
            var strTagStrippedText = strInputCode.replace(/<\/?[^>]+(>|$)/g, '');
            textarea.innerHTML = strTagStrippedText;

            //console.log("Input text:\n" + strInputCode + "\n\nOutput text:\n" + strTagStrippedText);
        }

        function isElementHidden(el) {
            return (el === undefined || el === null || el.className.indexOf('if-hide') >= 0);
        }
        function _addUploadBlob(aBlob, elementName, filename) {
            myInFlightDCInstance.addUploadBlob(aBlob, elementName, filename);
        }

        return {
            init: initialize,
            submitAction_win0: _submitAction_win0,
            setHTML5Date: setHTML5Date,
            getPeopleSoftSlashesDate: getPeopleSoftSlashesDate,
            stripHtml: stripHtml,
            isElementHidden: isElementHidden,
            jqSelector: jqSelector,
            addUploadBlob: _addUploadBlob,
            processDirectLink: _processDirectLink,
            saveScrollState: _saveScrollState,
            clearScrollStates: _clearScrollStates
            /*      ,
                    submitAction_win0: _submitAction_win0,
                    pAction_win0: _submitAction_win0,
                    hAction_win0: _hAction_win0
            */
        };
    };
    //}());


    window.InFlightPSHelperType = InFlightPSHelperType;
}());

var InFlightPSHelper = new InFlightPSHelperType();
